
    import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
    import {SweetModal} from 'sweet-modal-vue';
    import axiosInstance from '../../helpers/axios';
    import session from '@/stores/Session';
    import stores from '@/stores';

    @Component({
        components: {
            SweetModal,
        },
    })
    export default class EServices extends Vue {
        option: any = 'collection';
        @Prop()
        panel: any;
        services: [] = [];
        list: [] = [];
        data: any = {
          category: null,
          module: null,
          sortType: 'sort',
          ratio: 'image',
          quantity: 'all',
          data: [],
        };

        cancel() {
            // @ts-ignore
            this.$children[0].close();
            this.$emit('close', this.option);
            this.clearData();
        }

        mounted() {

              stores.modules.modules()
                  .then((response) => {
                      this.services = response;
                  });
        }
        isSelected(ration: string) {
          return this.data.ratio === ration;
        }
        updateRatio(option: string) {
          this.data.ratio = option;
        }

        update(option: string) {
                this.option = option;
        }

        isValidServiceType(type: string) {
            // return type ===
            return true;
        }

        clearData() {
            this.option = null;
            // this.services = [];
            this.list = [];
        }

        next() {
            const temp: any[] = [];
            for (const index in this.list) {
                if (index) {
                    // @ts-ignore
                    temp.push(this.services[this.list[index]]);
                }

            }
            this.$emit('response', temp);
            // @ts-ignore
            this.$children[0].close();
        }
    }
